import { Model } from './Model';

export enum Group {
  INSTITUTION = 'institution',
  CATEGORY = 'category',
  TYPE = 'type',
  ENERGYSECTOR = 'energySector',
  AVAILABILITY = 'availability',
  SEARCH = 'search',
}

export type Filter = {
  name: string | number;
  group: Group;
};

const isEqual = (model: Model, filter: Filter) => model[filter.group as keyof Model] === filter.name;

const isPresent = (model: Model, filter: Filter) => {
  return model.institution.some((el) => {
    return el === filter.name;
  });
};

function find(model: Model, filter: Filter) {
  const text = filter.name.toString().toLowerCase();
  const splitText = text.split(' ');

  return splitText.some((el) => {
    return (
      model.name.toLowerCase().includes(el) ||
      model.primaryUse.toLowerCase().includes(el) ||
      model.acronym.toLowerCase().includes(el)
    );
  });
}

function isShownByCategory(model: Model, filters: Filter[]) {
  const categoryFilters = filters?.filter((filter) => filter.group === Group.CATEGORY);
  if (!categoryFilters?.length) {
    return true;
  }
  return categoryFilters.some((filter) => isEqual(model, filter));
}

function isShownByInstitution(model: Model, filters: Filter[]) {
  const instituteFilters = filters?.filter((filter) => filter.group === Group.INSTITUTION);
  if (!instituteFilters?.length) {
    return true;
  }
  return instituteFilters.some((filter) => isPresent(model, filter));
}

function isShownByType(model: Model, filters: Filter[]) {
  const typeFilters = filters?.filter((filter) => filter.group === Group.TYPE);
  if (!typeFilters?.length) {
    return true;
  }
  return typeFilters.some((filter) => isEqual(model, filter));
}

function isShownByEnergySector(model: Model, filters: Filter[]) {
  const energySectorFilters = filters?.filter((filter) => filter.group === Group.ENERGYSECTOR);
  if (!energySectorFilters?.length) {
    return true;
  }
  return energySectorFilters.some((filter) => isEqual(model, filter));
}

function isShownByAvailability(model: Model, filters: Filter[]) {
  const availabilityFilters = filters?.filter((filter) => filter.group === Group.AVAILABILITY);
  if (!availabilityFilters?.length) {
    return true;
  }
  return availabilityFilters.some((filter) => isEqual(model, filter));
}

function isShownBySearch(model: Model, filters: Filter[]) {
  const searchFilters = filters?.filter((filter) => filter.group === Group.SEARCH);
  if (!searchFilters?.length) {
    return true;
  }
  return searchFilters.some((filter) => find(model, filter));
}

export function applyFilters(models: Model[], filters: Filter[]) {
  return models.filter((model) => {
    const showByCategory = isShownByCategory(model, filters);
    const showByInstitution = isShownByInstitution(model, filters);
    const showByType = isShownByType(model, filters);
    const showByEnergySector = isShownByEnergySector(model, filters);
    const showByAvailability = isShownByAvailability(model, filters);
    const showBySearch = isShownBySearch(model, filters);
    return (
      showByCategory && showByInstitution && showByType && showByEnergySector && showByAvailability && showBySearch
    );
  });
}
